<template>
  <vx-card no-shadow>

    <vs-input type="password" class="w-full mb-base" label="* 기존 비밀번호" v-model="old_password" />
    <vs-input type="password" class="w-full mb-base" label="* 신규 비밀번호" placeholder="6~32자리이상의 영문과 숫자로 입력해주세요." v-model="new_password" required />
    <vs-input type="password" class="w-full mb-base" label="* 신규 비밀번호 확인" placeholder="6~32자리이상의 영문과 숫자로 입력해주세요." v-model="confirm_new_password" />

    <!-- Save & Reset Button -->
    <div class="flex flex-wrap items-center justify-end">
      <vs-button class="ml-auto mt-2" @click="saveChanges">저장</vs-button>
      <vs-button class="ml-4 mt-2" type="border" color="warning">취소</vs-button>
    </div>
  </vx-card>
</template>

<script>

import { putData } from '@/api/module'

export default {
  data () {
    return {
      old_password: '',
      new_password: '',
      confirm_new_password: ''
    }
  },
  computed: {
  },
  methods: {
    async saveChanges () {
      
      if (this.old_password.length === 0 || this.new_password.length === 0) {
        this.$vs.notify({
          title: '알림',
          text: '비밀번호를 입력해 주세요.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
        return 
      }

      if (this.new_password !== this.confirm_new_password) {
        this.$vs.notify({
          title: '알림',
          text: '신규 비밀번호와 신규 비밀번호 확인이 일치하지 않습니다.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
        return
      }

      if (this.new_password.length < 6 ||  this.new_password.length > 32) {
        this.$vs.notify({
          title: '알림',
          text: '신규 비밀번호는 6~32자리 이상의 영문과 숫자로 입력해주세요.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
        return
      }
      
      try {
        await putData('/password', {
          oldPassword : this.old_password,
          newPassword : this.new_password
        })

        this.$vs.notify({
          title: '알림',
          text: '비밀번호가 변경되었습니다.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'primary'
        })

      } catch (error) {
        console.log(error)
        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }
    }
  }
}
</script>
